/**
 * @module
 * @name PhotoclaimGallery
 * @description Gallery to photoclaim photos.
 */
export default {
  name: 'PhotoclaimGallery',
  props: {
    damagedParts: {
      type: Array,
      default: function () {
        return []
      }
    },
    spacePhotos: {
      type: Array,
      default: function () {
        return []
      }
    },
    photosTaken: {
      type: Boolean,
      default: false
    },
    photosPerDamage: {
      required: false,
      type: Number,
      default: 3
    }
  },

  computed: {
    firstPhotos: function () {
      return (partDamages) =>
        partDamages[0].images.slice(0, this.photosPerDamage)
    },
    allDamagesConfirmed: function () {
      return (partDamages) => {
        return (
          partDamages.partDamages &&
          partDamages.partDamages.length !== 0 &&
          partDamages.every((damage) => damage.damageConfirmed)
        )
      }
    }
  },

  methods: {
    handleOnShowModal() {
      this.$emit('openPhotoclaimModal')
    },
    handleButtonConfirm(damagedPart) {
      this.$emit('confirmPhotoclaimDamages', damagedPart)
    },
    handleButtonAdd(damagePart) {
      this.$emit('add:photoclaimDamage', damagePart)
    },
    handleButtonEdit(damagePart, damageIndex) {
      this.$emit('edit:photoclaimDamage', damagePart, damageIndex)
    },
    handleButtonDelete(damagePart, damageIndex) {
      this.$emit('delete:photoclaimDamage', damagePart, damageIndex)
    }
  }
}
